import { render, staticRenderFns } from "./redeemsAnnouncement.vue?vue&type=template&id=1c1127c2&scoped=true"
import script from "./redeemsAnnouncement.vue?vue&type=script&lang=js"
export * from "./redeemsAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./redeemsAnnouncement.vue?vue&type=style&index=0&id=1c1127c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1127c2",
  null
  
)

export default component.exports